import * as React from 'react'
import {MobilityCardErrorBoundary} from './mobility-card-error-boundary'
import {QueryClientProvider} from '@tanstack/react-query'
import { reactQueryClient } from '@applications/utility-methods'
const DashboardCard = React.lazy(() => import(/* webpackChunkName: "mdum-card" */ './index'))
const MobilityServiceContainer = () => (
  <QueryClientProvider client={reactQueryClient}>
    <MobilityCardErrorBoundary>
      <React.Suspense fallback={<></>}>
        <DashboardCard uiid="ui-mdum-surface-container-card" />
      </React.Suspense>
    </MobilityCardErrorBoundary>
  </QueryClientProvider>
)

export default MobilityServiceContainer
